export default __webpack_public_path__ + "static/media/Morph Undead.84d116c6.jpg";